<template>
  <div>
    <y-periodselector
      @period="periodselected"
      :iscierre="true"
      :period="period"
    ></y-periodselector>
    <div class="field is-grouped">
      <div class="control">
        <div class="select">
          <select v-model="ccosto">
            <option
              v-for="(costo, index) in ccostos"
              :key="index"
              :value="costo.codigo"
            >
              {{ costo.codigo }} {{ costo.nombre }}
            </option>
          </select>
        </div>
      </div>
      <div class="control">
        <button type="submit" class="button is-link" @click="search">
          <span class="icon is-small">
            <span class="material-icons">search</span>
          </span>
          <span>Buscar</span>
        </button>
      </div>
      <div class="control">
        <button type="submit" class="button is-light" @click="imprimir">
          <span class="icon is-small">
            <span class="material-icons">print</span>
          </span>
          <span>Imprimir</span>
        </button>
      </div>
      <div class="control">
        <button
          type="submit"
          class="button is-light"
          v-if="bprueba.length !== 0"
          @click="descargarBalance"
        >
          <span class="icon is-small">
            <span class="material-icons">archive</span>
          </span>
          <span>Descargar</span>
        </button>
      </div>
      <div class="control">
        <button
          type="submit"
          class="button is-info"
          @click="descargarBalancextercero"
        >
          <span class="icon is-small">
            <span class="material-icons">file_download</span>
          </span>
          <span>Descargar por tercero</span>
        </button>
      </div>
      <div class="control">
        <button
          type="submit"
          class="button is-dark"
          @click="descargarAuxiliarGeneral"
        >
          <span class="icon is-small">
            <span class="material-icons">file_download</span>
          </span>
          <span>Auxiliar general acumulado</span>
        </button>
      </div>
    </div>
    <div id="printbalance" class="table-container">
      <span style="font-size: 20px">
        <strong>{{ empresa.nombrec }}</strong>
        <small>
          <strong
            >{{ empresa.nit | textnumber()
            }}{{ empresa.nit | dverif() }}</strong
          >
        </small>
        <small style="font-size: 70%; color: #7a7a7a">{{
          empresa.nombre
        }}</small>
        <br />
        Balance de cuenta {{ periodo | periodo()
        }}{{ ccosto !== "" ? `, Centro de Costos ${nccosto}` : "" }}
      </span>
      <table style="width: 100%; font-size: 14px" class="fontMono">
        <tr style="background-color: #f3f3f3">
          <th
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
            "
          >
            Código
          </th>
          <th
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
            "
          >
            Nombre
          </th>
          <th
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            S Inicial
          </th>
          <th
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            Debito
          </th>
          <th
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            Credito
          </th>
          <th
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            S Final
          </th>
        </tr>
        <tr v-for="(cuenta, index) in bprueba" :key="index">
          <td style="padding: 2px" :style="styleTr(cuenta)">
            {{ cuenta.codigoCuenta }}
          </td>
          <td style="padding: 2px" :style="styleTr(cuenta)">
            {{ cuenta.nombreCuenta }}
          </td>
          <td style="padding: 2px; text-align: right" :style="styleTr(cuenta)">
            {{ cuenta.saldoInicial | number(2) }}
          </td>
          <td
            style="padding: 2px 2px 2px 8px; text-align: right"
            :style="styleTr(cuenta, 'debito')"
            @mouseover="hovercuenta(cuenta, 'debito')"
            @mouseleave="leavecuenta"
            @click="auxiliar(cuenta, 'movimiento')"
          >
            {{ cuenta.debito | number(2) }}
          </td>
          <td
            style="padding: 2px 2px 2px 8px; text-align: right"
            :style="styleTr(cuenta, 'credito')"
            @mouseover="hovercuenta(cuenta, 'credito')"
            @mouseleave="leavecuenta"
            @click="auxiliar(cuenta, 'movimiento')"
          >
            {{ cuenta.credito | number(2) }}
          </td>
          <td
            style="padding: 2px 2px 2px 8px; text-align: right"
            :style="styleTr(cuenta, 'sfinal')"
            @mouseover="hovercuenta(cuenta, 'sfinal')"
            @mouseleave="leavecuenta"
            @click="auxiliar(cuenta, 'saldo')"
          >
            {{ (cuenta.saldoInicial + cuenta.mvto) | number(2) }}
          </td>
        </tr>
        <tr style="background-color: #f3f3f3">
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
            "
          >
            <strong>T</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
            "
          >
            <strong>Total</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>{{ totales.saldoInicial | number(2) }}</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>{{ totales.debito | number(2) }}</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>{{ totales.credito | number(2) }}</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>{{
              (totales.saldoInicial + totales.debito - totales.credito)
                | number(2)
            }}</strong>
          </td>
        </tr>
      </table>
    </div>
    <y-saldomodalbalance
      :show="showmodalsaldobalance"
      :datamodal="dataemergente"
      :period="period"
      @showmodalsbalance="showmodalsbalance"
    ></y-saldomodalbalance>
  </div>
</template>

<script>
import functions from "@/helpers/functions";
import apiServices from "@/services/yungol-services";
import yPeriodselector from "@/components/commons/PeriodselectorV2.vue";
import ySaldomodalbalance from "@/components/modals/SaldoModalBalance2.vue";
import { mapState } from "vuex";
const XLSX = require("xlsx");
function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
export default {
  data() {
    return {
      showmodalsaldobalance: false,
      dataemergente: {},
      hoverbalance: {
        codigo: null,
        lugar: null,
      },
      cuentas: [],
      bprueba: [],
      ccostos: [],
      period: {
        year: null,
        months: null,
      },
      ccosto: "",
      totales: {
        saldoInicial: 0,
        debito: 0,
        credito: 0,
      },
      totalesC: {
        saldoInicial: 0,
        debito: 0,
        credito: 0,
      },
      saldos: [],
      movimientos: [],
    };
  },
  computed: {
    ...mapState(["empresa", "nits"]),
    periodo() {
      const year = this.period.year;
      let month = this.period.months[0];
      month = month.toString();
      if (month.length === 1) {
        month = `0${month}`;
      }
      return `${year}${month}`;
    },
    nccosto() {
      let ncosto = "";
      const _this = this;
      for (let index = 0; index < this.ccostos.length; index++) {
        const ccosto = _this.ccostos[index];
        if (ccosto.codigo === _this.ccosto) {
          ncosto = ccosto.nombre;
        }
      }
      return ncosto;
    },
  },
  methods: {
    async descargarAuxiliarGeneral() {
      try {
        const _this = this;
        const query = {
          period: this.period,
          year: this.period.year,
          mes: this.period.months[0],
        };
        const result = await apiServices.post(`/auxgeneral`, query);
        if (result.data) {
          console.log(result.data);
          let grupos = [];
          let sgrupos = [];
          let scuentas = [];
          let scuentas1 = [];
          const cuentas = [];
          const datacuentas = {};
          const totalesx = {
            saldoInicial: 0,
            debito: 0,
            credito: 0,
          };
          for (let index in this.cuentas) {
            const cuenta = _this.cuentas[index];
            datacuentas[cuenta.codigo] = cuenta;
          }
          for (let index in result.data.bprueba) {
            const key = result.data.bprueba[index];
            totalesx.saldoInicial += key.saldoInicial;
            totalesx.debito += key.debito;
            totalesx.credito += key.credito;
            key.grupo = key.codigoCuenta.substr(0, 1);
            key.sgrupo = key.codigoCuenta.substr(0, 2);
            key.scuentas = key.codigoCuenta.substr(0, 4);
            key.scuentas1 = key.codigoCuenta.substr(0, 6);
            key.tipo = "cuenta";
            grupos.push(key.codigoCuenta.substr(0, 1));
            sgrupos.push(key.codigoCuenta.substr(0, 2));
            scuentas.push(key.codigoCuenta.substr(0, 4));
            scuentas1.push(key.codigoCuenta.substr(0, 6));
            cuentas.push(key);
          }
          grupos = grupos.filter(onlyUnique);
          sgrupos = sgrupos.filter(onlyUnique);
          scuentas = scuentas.filter(onlyUnique);
          scuentas1 = scuentas1.filter(onlyUnique);
          for (let v in grupos) {
            const k = grupos[v];
            const grupoValor = {
              codigoCuenta: "",
              saldoInicial: 0,
              debito: 0,
              credito: 0,
              mvto: 0,
              tipo: "grupo",
              nombreCuenta: datacuentas[k]
                ? datacuentas[k].nombre
                : "haga el query de las cuentas",
            };
            for (let v1 in result.data.bprueba) {
              const k1 = result.data.bprueba[v1];
              if (k === k1.codigoCuenta.substr(0, 1)) {
                grupoValor.codigoCuenta = k;
                grupoValor.saldoInicial += k1.saldoInicial;
                grupoValor.debito += k1.debito;
                grupoValor.credito += k1.credito;
                grupoValor.mvto += k1.debito - k1.credito;
              }
            }
            cuentas.push(grupoValor);
          }
          for (let v in sgrupos) {
            const k = sgrupos[v];
            const grupoValor = {
              codigoCuenta: "",
              saldoInicial: 0,
              debito: 0,
              credito: 0,
              mvto: 0,
              tipo: "subGrupo",
              nombreCuenta: datacuentas[k]
                ? datacuentas[k].nombre
                : "haga el query de las cuentas",
            };
            for (let v1 in result.data.bprueba) {
              const k1 = result.data.bprueba[v1];
              if (k === k1.codigoCuenta.substr(0, 2)) {
                grupoValor.codigoCuenta = k;
                grupoValor.saldoInicial += k1.saldoInicial;
                grupoValor.debito += k1.debito;
                grupoValor.credito += k1.credito;
                grupoValor.mvto += k1.debito - k1.credito;
              }
            }
            cuentas.push(grupoValor);
          }
          for (let v in scuentas) {
            const k = scuentas[v];
            const grupoValor = {
              codigoCuenta: "",
              saldoInicial: 0,
              debito: 0,
              credito: 0,
              mvto: 0,
              tipo: "subCuenta",
              nombreCuenta: datacuentas[k]
                ? datacuentas[k].nombre
                : "haga el query de las cuentas",
            };
            for (let v1 in result.data.bprueba) {
              const k1 = result.data.bprueba[v1];
              if (k === k1.codigoCuenta.substr(0, 4)) {
                grupoValor.codigoCuenta = k;
                grupoValor.saldoInicial += k1.saldoInicial;
                grupoValor.debito += k1.debito;
                grupoValor.credito += k1.credito;
                grupoValor.mvto += k1.debito - k1.credito;
              }
            }
            cuentas.push(grupoValor);
          }
          for (let v in scuentas1) {
            const k = scuentas1[v];
            const esRegistro = datacuentas[k].esRegistro;
            const grupoValor = {
              codigoCuenta: "",
              saldoInicial: 0,
              debito: 0,
              credito: 0,
              mvto: 0,
              tipo: "subCuenta1",
              nombreCuenta: datacuentas[k]
                ? datacuentas[k].nombre
                : "haga el query de las cuentas",
            };
            if (!esRegistro) {
              for (let v1 in result.data.bprueba) {
                const k1 = result.data.bprueba[v1];
                if (k === k1.codigoCuenta.substr(0, 6)) {
                  grupoValor.codigoCuenta = k;
                  grupoValor.saldoInicial += k1.saldoInicial;
                  grupoValor.debito += k1.debito;
                  grupoValor.credito += k1.credito;
                  grupoValor.mvto += k1.debito - k1.credito;
                }
              }
              cuentas.push(grupoValor);
            }
          }
          for (let index in result.data.mvto) {
            const mv = result.data.mvto[index];
            const d = {};
            d.codigoCuenta = mv.idcuenta.codigo;
            d.saldoInicial = "";
            d.debito = parseInt(mv.tipo) === 1 ? mv.valor : 0;
            d.credito = parseInt(mv.tipo) !== 1 ? mv.valor : 0;
            d.mvto = parseInt(mv.tipo) === 1 ? mv.valor : -mv.valor;
            d.nombreCuenta = mv.idcuenta.nombre;
            d.codComprobante = mv.comprobanteid.codigo;
            d.documento = mv.documento;
            d.fecha = mv.fecha;
            d.descripcion = mv.descripcion;
            d.codigoNit = mv.idnit.codigo;
            d.nombreTercero = mv.idnit.nombre;
            d.docRef = mv.docRef;
            d.ccostos = mv.ccostos;
            d.isMvto = true;
            cuentas.push(d);
          }
          cuentas.sort(function (a, b) {
            if (a.codigoCuenta < b.codigoCuenta) {
              return -1;
            }
            if (a.codigoCuenta > b.codigoCuenta) {
              return 1;
            }
            return 0;
          });
          const data2export = [];
          for (let index in cuentas) {
            const c = cuentas[index];
            const data2push = {
              "Codigo cuenta": c.codigoCuenta,
              "Nombre cuenta": c.nombreCuenta,
              Tipo: c.isMvto ? "Movimiento" : "Saldo",
              Comprobante: c.codComprobante ? c.codComprobante : "",
              Documento: c.documento ? c.documento : "",
              Fecha: c.fecha ? c.fecha : "",
              Descripcion: c.isMvto ? c.descripcion : "",
              Nit: `${c.codigoNit ? c.codigoNit : ""}`,
              Nombre: `${c.nombreTercero ? c.nombreTercero : ""}`,
              DocRef: c.docRef ? c.docRef : "",
              Ccosto: c.ccostos ? c.ccostos : "",
              S_Inicial: c.saldoInicial,
              Debito: c.debito,
              Credito: c.credito,
              S_Final: c.saldoInicial ? c.saldoInicial + c.mvto : "",
            };
            data2export.push(data2push);
          }
          let data = XLSX.utils.json_to_sheet(data2export);
          const workbook = XLSX.utils.book_new();
          const filename = `Aux acumulado ${this.fecha1(this.period)}`;
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        }
      } catch (err) {
        console.log(err);
      }
    },
    fecha1(p) {
      const month = p.months[0];
      const namesmonths = {
        1: "ene",
        2: "feb",
        3: "mzo",
        4: "abr",
        5: "myo",
        6: "jun",
        7: "jul",
        8: "ago",
        9: "sep",
        10: "oct",
        11: "nov",
        12: "dic",
      };
      return `${namesmonths[month]}-${p.year}`;
    },
    async descargarBalancextercero() {
      try {
        const _this = this;
        let grupos = [];
        let sgrupos = [];
        let scuentas = [];
        let scuentas1 = [];
        const cuentas = [];
        const datacuentas = {};
        const totalesx = {
          saldoInicial: 0,
          debito: 0,
          credito: 0,
        };
        for (let index in this.cuentas) {
          const cuenta = _this.cuentas[index];
          datacuentas[cuenta.codigo] = cuenta;
        }
        const query = {
          period: this.period,
          year: this.period.year,
          mes: this.period.months[0],
          ccosto: this.ccosto,
          tcc: this.ccosto ? 1 : 0,
        };
        const result = await apiServices.post(`/bpruebaxtercero`, query);
        if (result.data) {
          for (let index in result.data) {
            const key = result.data[index];
            totalesx.saldoInicial += key.saldoInicial;
            totalesx.debito += key.debito;
            totalesx.credito += key.credito;
            key.grupo = key.codigoCuenta.substr(0, 1);
            key.sgrupo = key.codigoCuenta.substr(0, 2);
            key.scuentas = key.codigoCuenta.substr(0, 4);
            key.scuentas1 = key.codigoCuenta.substr(0, 6);
            key.tipo = "cuenta";
            grupos.push(key.codigoCuenta.substr(0, 1));
            sgrupos.push(key.codigoCuenta.substr(0, 2));
            scuentas.push(key.codigoCuenta.substr(0, 4));
            scuentas1.push(key.codigoCuenta.substr(0, 6));
            cuentas.push(key);
          }
          grupos = grupos.filter(onlyUnique);
          sgrupos = sgrupos.filter(onlyUnique);
          scuentas = scuentas.filter(onlyUnique);
          scuentas1 = scuentas1.filter(onlyUnique);
          for (let v in grupos) {
            const k = grupos[v];
            const grupoValor = {
              codigoCuenta: "",
              saldoInicial: 0,
              debito: 0,
              credito: 0,
              mvto: 0,
              tipo: "grupo",
              nombreCuenta: datacuentas[k]
                ? datacuentas[k].nombre
                : "haga el query de las cuentas",
            };
            for (let v1 in result.data) {
              const k1 = result.data[v1];
              if (k === k1.codigoCuenta.substr(0, 1)) {
                grupoValor.codigoCuenta = k;
                grupoValor.saldoInicial += k1.saldoInicial;
                grupoValor.debito += k1.debito;
                grupoValor.credito += k1.credito;
                grupoValor.mvto += k1.debito - k1.credito;
              }
            }
            cuentas.push(grupoValor);
          }
          for (let v in sgrupos) {
            const k = sgrupos[v];
            const grupoValor = {
              codigoCuenta: "",
              saldoInicial: 0,
              debito: 0,
              credito: 0,
              mvto: 0,
              tipo: "subGrupo",
              nombreCuenta: datacuentas[k]
                ? datacuentas[k].nombre
                : "haga el query de las cuentas",
            };
            for (let v1 in result.data) {
              const k1 = result.data[v1];
              if (k === k1.codigoCuenta.substr(0, 2)) {
                grupoValor.codigoCuenta = k;
                grupoValor.saldoInicial += k1.saldoInicial;
                grupoValor.debito += k1.debito;
                grupoValor.credito += k1.credito;
                grupoValor.mvto += k1.debito - k1.credito;
              }
            }
            cuentas.push(grupoValor);
          }
          for (let v in scuentas) {
            const k = scuentas[v];
            const grupoValor = {
              codigoCuenta: "",
              saldoInicial: 0,
              debito: 0,
              credito: 0,
              mvto: 0,
              tipo: "subCuenta",
              nombreCuenta: datacuentas[k]
                ? datacuentas[k].nombre
                : "haga el query de las cuentas",
            };
            for (let v1 in result.data) {
              const k1 = result.data[v1];
              if (k === k1.codigoCuenta.substr(0, 4)) {
                grupoValor.codigoCuenta = k;
                grupoValor.saldoInicial += k1.saldoInicial;
                grupoValor.debito += k1.debito;
                grupoValor.credito += k1.credito;
                grupoValor.mvto += k1.debito - k1.credito;
              }
            }
            cuentas.push(grupoValor);
          }
          for (let v in scuentas1) {
            const k = scuentas1[v];
            const esRegistro = datacuentas[k].esRegistro;
            const grupoValor = {
              codigoCuenta: "",
              saldoInicial: 0,
              debito: 0,
              credito: 0,
              mvto: 0,
              tipo: "subCuenta1",
              nombreCuenta: datacuentas[k]
                ? datacuentas[k].nombre
                : "haga el query de las cuentas",
            };
            if (!esRegistro) {
              for (let v1 in result.data) {
                const k1 = result.data[v1];
                if (k === k1.codigoCuenta.substr(0, 6)) {
                  grupoValor.codigoCuenta = k;
                  grupoValor.saldoInicial += k1.saldoInicial;
                  grupoValor.debito += k1.debito;
                  grupoValor.credito += k1.credito;
                  grupoValor.mvto += k1.debito - k1.credito;
                }
              }
              cuentas.push(grupoValor);
            }
          }
          cuentas.sort(function (a, b) {
            if (a.codigoCuenta < b.codigoCuenta) {
              return -1;
            }
            if (a.codigoCuenta > b.codigoCuenta) {
              return 1;
            }
            return 0;
          });
          const data2export = [];
          for (let index in cuentas) {
            const cuenta = cuentas[index];
            const data2push = {
              Codigo: cuenta.codigoCuenta,
              Cuenta: cuenta.nombreCuenta,
              Nit: cuenta.codigoNit ? cuenta.codigoNit : "",
              Nombre: cuenta.nombreTercero ? cuenta.nombreTercero : "",
              S_Inicial: functions.dosDecimales(cuenta.saldoInicial),
              Debito: functions.dosDecimales(cuenta.debito),
              Credito: functions.dosDecimales(cuenta.credito),
              S_Final: functions.dosDecimales(
                cuenta.saldoInicial + cuenta.mvto
              ),
            };
            data2export.push(data2push);
          }
          const data2pushTotal = {
            // aqui se totaliza para que no muestre todos esos decimales
            Codigo: "T",
            Cuenta: "Total",
            Nit: "",
            Nombre: "",
            S_Inicial: functions.dosDecimales(totalesx.saldoInicial),
            Debito: functions.dosDecimales(totalesx.debito),
            Credito: functions.dosDecimales(totalesx.credito),
            S_Final: functions.dosDecimales(
              totalesx.saldoInicial + totalesx.debito - totalesx.credito
            ),
          };
          data2export.push(data2pushTotal);
          let data = XLSX.utils.json_to_sheet(data2export);
          const workbook = XLSX.utils.book_new();
          const filename = "Balance por tercero " + this.periodo;
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        }
      } catch (err) {
        console.log(err);
      }
    },
    decimals(number) {
      let entero = parseInt(number * 100);
      entero = parseFloat(entero / 100);
      return entero;
    },
    descargarBalance() {
      const _this = this;
      const data2export = [];
      for (let index in this.bprueba) {
        const cuenta = _this.bprueba[index];
        const data2push = {
          Codigo: cuenta.codigoCuenta,
          Nombre: cuenta.nombreCuenta,
          S_Inicial: cuenta.saldoInicial,
          Debito: cuenta.debito,
          Credito: cuenta.credito,
          S_Final: cuenta.saldoInicial + cuenta.mvto,
        };
        data2export.push(data2push);
      }

      const data2pushTotal = {
        // aqui se totaliza para que no muestre todos esos decimales
        Codigo: "T",
        Nombre: "Total",
        S_Inicial: this.decimals(this.totales.saldoInicial),
        Debito: this.decimals(this.totales.debito),
        Credito: this.decimals(this.totales.credito),
        S_Final: this.decimals(
          this.totales.saldoInicial + this.totales.debito - this.totales.credito
        ),
      };
      data2export.push(data2pushTotal);

      let data = XLSX.utils.json_to_sheet(data2export);
      const workbook = XLSX.utils.book_new();
      const filename = "Balance de cuenta " + this.periodo;
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    showmodalsbalance(payload) {
      this.showmodalsaldobalance = payload;
    },
    openBP(datos, codigo, nombre, tipo, totales, titulo) {
      this.dataemergente.codigoCuenta = codigo;
      this.dataemergente.nombreCuenta = nombre;
      this.dataemergente.tipoReporte = tipo;
      this.dataemergente.detalles = datos;
      this.dataemergente.totales = totales;
      this.dataemergente.titulo = titulo;
      this.showmodalsaldobalance = true;
    },
    async auxiliar(q, b) {
      try {
        const _this = this;
        const titulo = {};
        if (q.tipo === "cuenta") {
          let c = "tercero";
          if (b === "saldo") {
            c = "tercero";
          } else {
            c = "cuenta";
          }
          const consulta = {};
          consulta.year = this.period.year;
          consulta.mes = this.period.months[0];
          consulta.tipo = b;
          consulta.tipo2 = "cuenta";
          consulta.orden = c;
          consulta.idConsulta = q.idcuenta;
          consulta.tcc = this.ccosto ? 1 : 0;
          consulta.ccosto = this.ccosto;
          consulta.nccosto = this.nccosto;
          const result = await apiServices.post(`/reportecontador`, consulta);
          if (result.data) {
            const a = result.data;
            this.totalesC = {
              saldoInicial: 0,
              debito: 0,
              credito: 0,
            };
            if (b === "saldo") {
              let terceros = [];
              const saldosOrdenados = [];

              a.forEach(function (key) {
                _this.totalesC.saldoInicial += key.saldoInicial;
                _this.totalesC.debito += key.debito;
                _this.totalesC.credito += key.credito;
                terceros.push(key.idtercero);
              });
              terceros = terceros.filter(onlyUnique);
              terceros.forEach(function (k) {
                var t = {
                  id: k,
                  saldoInicial: 0,
                  debito: 0,
                  credito: 0,
                  mvto: 0,
                  clase: "subTotales",
                };
                a.forEach(function (k1, v1) {
                  k1.orden = v1;
                  k1.clase = "valores";
                  if (k === k1.idtercero) {
                    t.codigoNit = k1.codigoNit;
                    t.nombreTercero = k1.nombreTercero;
                    t.tieneTercero = k1.tieneTercero;
                    t.tieneDocRef = k1.tieneDocRef;
                    t.tieneCcosto = k1.tieneCcosto;
                    t.ccosto = k1.ccostos;
                    t.saldoInicial = t.saldoInicial + k1.saldoInicial;
                    t.debito = t.debito + k1.debito;
                    t.credito = t.credito + k1.credito;
                    t.mvto = t.mvto + t.debito - t.credito;
                    saldosOrdenados.push(k1);
                  }
                });
                saldosOrdenados.push(t);
              });
              this.saldos = saldosOrdenados;
              titulo.orden = "tercero";
              titulo.idconsulta = q.idcuenta;
              titulo.nombreconsulta = q.nombreCuenta;
              this.openBP(
                this.saldos,
                q.codigoCuenta,
                q.nombreCuenta,
                consulta.tipo,
                this.totalesC,
                titulo
              );
            } else {
              this.movimientos = a;
              titulo.orden = "cuenta";
              titulo.idconsulta = q.idcuenta;
              titulo.nombreconsulta = q.nombreCuenta;
              this.openBP(
                this.movimientos,
                q.codigoCuenta,
                q.nombreCuenta,
                consulta.tipo,
                this.totalesC,
                titulo
              );
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    imprimir() {
      // functions.imprimir(this.data.comprobante.nombre,this.data.documento,this.data.mes.codigo);
      this.$print("printbalance", {
        name: `Balance de cuenta ${this.empresa.nombrec} ${this.empresa.nit} ${this.periodo}`,
      });
    },
    leavecuenta() {
      this.hoverbalance.codigo = null;
      this.hoverbalance.lugar = null;
    },
    hovercuenta(cuenta, lugar) {
      this.hoverbalance.codigo = cuenta.codigoCuenta;
      this.hoverbalance.lugar = lugar;
    },
    styleTr(cuenta, lugar) {
      if (cuenta.tipo === "grupo") {
        return {
          "padding-top": "30px",
          "font-weight": "bold",
          "border-bottom": "1px solid #dbdbdb",
          color: "black",
        };
      }
      if (cuenta.tipo === "subGrupo") {
        return {
          "padding-top": "15px",
          "font-weight": "bold",
          color: "black",
        };
      }
      if (cuenta.tipo === "subCuenta") {
        return {
          "padding-top": "15px",
          "font-weight": "bold",
        };
      }
      if (cuenta.tipo === "cuenta") {
        if (
          lugar &&
          this.hoverbalance.codigo === cuenta.codigoCuenta &&
          this.hoverbalance.lugar === lugar
        ) {
          return { color: "blue", cursor: "pointer" };
        } else {
          return {
            color: "#adadad",
          };
        }
      }
    },
    async getCuentas() {
      try {
        const result = await apiServices.get(`/cuentas`);
        this.cuentas = result.data;
      } catch (err) {
        console.log(err);
      }
    },
    changeccosto() {
      this.transformData();
    },
    async search() {
      const _this = this;
      let grupos = [];
      let sgrupos = [];
      let scuentas = [];
      let scuentas1 = [];
      const cuentas = [];
      const datacuentas = {};
      this.totales = {
        saldoInicial: 0,
        debito: 0,
        credito: 0,
      };
      for (let index in this.cuentas) {
        const cuenta = _this.cuentas[index];
        datacuentas[cuenta.codigo] = cuenta;
      }
      try {
        const query = {
          period: this.period,
          year: this.period.year,
          mes: this.period.months[0],
          ccosto: this.ccosto,
          tcc: this.ccosto ? 1 : 0,
        };
        const result = await apiServices.post(`/bprueba`, query);
        for (let index in result.data) {
          const key = result.data[index];
          _this.totales.saldoInicial += key.saldoInicial;
          _this.totales.debito += key.debito;
          _this.totales.credito += key.credito;
          key.grupo = key.codigoCuenta.substr(0, 1);
          key.sgrupo = key.codigoCuenta.substr(0, 2);
          key.scuentas = key.codigoCuenta.substr(0, 4);
          key.scuentas1 = key.codigoCuenta.substr(0, 6);
          key.tipo = "cuenta";
          grupos.push(key.codigoCuenta.substr(0, 1));
          sgrupos.push(key.codigoCuenta.substr(0, 2));
          scuentas.push(key.codigoCuenta.substr(0, 4));
          scuentas1.push(key.codigoCuenta.substr(0, 6));
          cuentas.push(key);
        }
        grupos = grupos.filter(onlyUnique);
        sgrupos = sgrupos.filter(onlyUnique);
        scuentas = scuentas.filter(onlyUnique);
        scuentas1 = scuentas1.filter(onlyUnique);
        for (let v in grupos) {
          const k = grupos[v];
          const grupoValor = {
            codigoCuenta: "",
            saldoInicial: 0,
            debito: 0,
            credito: 0,
            mvto: 0,
            tipo: "grupo",
            nombreCuenta: datacuentas[k]
              ? datacuentas[k].nombre
              : "haga el query de las cuentas",
          };
          for (let v1 in result.data) {
            const k1 = result.data[v1];
            if (k === k1.codigoCuenta.substr(0, 1)) {
              grupoValor.codigoCuenta = k;
              grupoValor.saldoInicial += k1.saldoInicial;
              grupoValor.debito += k1.debito;
              grupoValor.credito += k1.credito;
              grupoValor.mvto += k1.debito - k1.credito;
            }
          }
          cuentas.push(grupoValor);
        }
        for (let v in sgrupos) {
          const k = sgrupos[v];
          const grupoValor = {
            codigoCuenta: "",
            saldoInicial: 0,
            debito: 0,
            credito: 0,
            mvto: 0,
            tipo: "subGrupo",
            nombreCuenta: datacuentas[k]
              ? datacuentas[k].nombre
              : "haga el query de las cuentas",
          };
          for (let v1 in result.data) {
            const k1 = result.data[v1];
            if (k === k1.codigoCuenta.substr(0, 2)) {
              grupoValor.codigoCuenta = k;
              grupoValor.saldoInicial += k1.saldoInicial;
              grupoValor.debito += k1.debito;
              grupoValor.credito += k1.credito;
              grupoValor.mvto += k1.debito - k1.credito;
            }
          }
          cuentas.push(grupoValor);
        }
        for (let v in scuentas) {
          const k = scuentas[v];
          const grupoValor = {
            codigoCuenta: "",
            saldoInicial: 0,
            debito: 0,
            credito: 0,
            mvto: 0,
            tipo: "subCuenta",
            nombreCuenta: datacuentas[k]
              ? datacuentas[k].nombre
              : "haga el query de las cuentas",
          };
          for (let v1 in result.data) {
            const k1 = result.data[v1];
            if (k === k1.codigoCuenta.substr(0, 4)) {
              grupoValor.codigoCuenta = k;
              grupoValor.saldoInicial += k1.saldoInicial;
              grupoValor.debito += k1.debito;
              grupoValor.credito += k1.credito;
              grupoValor.mvto += k1.debito - k1.credito;
            }
          }
          cuentas.push(grupoValor);
        }
        for (let v in scuentas1) {
          const k = scuentas1[v];
          const esRegistro = datacuentas[k].esRegistro;
          const grupoValor = {
            codigoCuenta: "",
            saldoInicial: 0,
            debito: 0,
            credito: 0,
            mvto: 0,
            tipo: "subCuenta1",
            nombreCuenta: datacuentas[k]
              ? datacuentas[k].nombre
              : "haga el query de las cuentas",
          };
          if (!esRegistro) {
            for (let v1 in result.data) {
              const k1 = result.data[v1];
              if (k === k1.codigoCuenta.substr(0, 6)) {
                grupoValor.codigoCuenta = k;
                grupoValor.saldoInicial += k1.saldoInicial;
                grupoValor.debito += k1.debito;
                grupoValor.credito += k1.credito;
                grupoValor.mvto += k1.debito - k1.credito;
              }
            }
            cuentas.push(grupoValor);
          }
        }
        cuentas.sort(function (a, b) {
          if (a.codigoCuenta < b.codigoCuenta) {
            return -1;
          }
          if (a.codigoCuenta > b.codigoCuenta) {
            return 1;
          }
          return 0;
        });
        this.bprueba = cuentas;
      } catch (err) {
        console.log(err);
      }
    },
    resetbalance() {
      this.totales = {
        saldoInicial: 0,
        debito: 0,
        credito: 0,
      };
      this.totalesC = {
        saldoInicial: 0,
        debito: 0,
        credito: 0,
      };
      this.saldos = [];
      this.movimientos = [];
      this.bprueba = [];
    },
    periodselected(period) {
      this.period = period;
      this.resetbalance();
    },
    async getccostos() {
      const _this = this;
      const result = await apiServices.get(`/ccostos`);
      this.ccostos = [
        {
          codigo: "",
          nombre: "Centro de Costos",
        },
      ];
      for (let index in result.data) {
        _this.ccostos.push(result.data[index]);
      }
    },
  },
  created() {
    this.getccostos();
    this.getCuentas();
    const today = new Date();
    this.period.year = today.getFullYear();
    this.period.months = [today.getMonth() + 1];
  },
  components: {
    yPeriodselector,
    ySaldomodalbalance,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/reports/accountbalance/Accountbalancebeta.vue